// Header social icons — staggered hover reveal.
// Builds three stacked layers from the icon's SVG so each can slide up on its
// own delay: (1) the black icon slides up and out, (2) a black disc slides up,
// (3) a white copy of the icon slides up. Reverses on mouse-out. CSS does the
// motion and the stagger. No-ops when the icons aren't on the page.

export function initSocialIcons() {
    const icons = document.querySelectorAll('.header__icon');
    if (!icons.length) return;

    icons.forEach((icon) => {
        if (icon.dataset.hoverInit) return;
        icon.dataset.hoverInit = 'true';

        const svg = icon.querySelector('svg');
        if (!svg) return;

        // Layer 1: the resting black icon (wraps the existing SVG).
        const base = document.createElement('span');
        base.className = 'header__icon__layer header__icon__layer--base';
        svg.replaceWith(base);
        base.appendChild(svg);

        // Layer 2: plain black disc (no icon).
        const disc = document.createElement('span');
        disc.className = 'header__icon__layer header__icon__layer--disc';
        disc.setAttribute('aria-hidden', 'true');

        // Layer 3: white copy of the icon.
        const white = document.createElement('span');
        white.className = 'header__icon__layer header__icon__layer--white';
        white.setAttribute('aria-hidden', 'true');
        white.appendChild(svg.cloneNode(true));

        // Keep the screen-reader text last so the clones don't disturb it.
        const srText = icon.querySelector('.screen-reader-text');
        const before = srText || null;
        icon.insertBefore(disc, before);
        icon.insertBefore(white, before);
    });
}
